module.exports = __webpack_public_path__ + "media/night/119-787a56e5.svg";